import client from '@common/utils/rest';

const URL_PREFIX = 'api/folders';

export const getFolders = async () => {
  return client({
    path: `${URL_PREFIX}?context=1`,
    method: 'GET'
  }).then(
    (response) => {
      return response.entity;
    },
  );
};
